import type { GrantedUsersFetchedPayload } from '@Application/SubjectTypeDefinitions/Actions/grantedUsersFetched';

export type GrantableUsersFoundPayload = GrantedUsersFetchedPayload;

export type GrantableUsersFoundAction = {
	type: 'GRANTABLE_USERS_FOUND';
	payload: GrantableUsersFoundPayload;
	accountId: number;
};

export default (payload: GrantableUsersFoundPayload, accountId: number): GrantableUsersFoundAction => ({
	type: 'GRANTABLE_USERS_FOUND',
	payload,
	accountId,
});
